
import axios from 'axios';
import { BASE_URL } from './constants';
import Swal from 'sweetalert2';

export function PrintElem(content, width = 900, height = 500) {
  var mywindow = window.open("", "PRINT", `height=${height},width=${width}`);
  if (!mywindow) {
    return false;
  }
  mywindow.document.write(content);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.onafterprint = () => {
    console.log("After print");
    //mywindow.close();
  };

  let printed = false;
  const triggerPrint = () => {
    if (!printed) {
      printed = true;
      mywindow.focus();
      mywindow.print();
    }
  };

  mywindow.onload = triggerPrint;
  setTimeout(triggerPrint, 500);

  return true;
}


const roundNumber = (number) => {
  let modifiedNumber = number;
  if (number % 1 != 0) {
    modifiedNumber = parseFloat(number).toFixed(2);
  }

  if (isNaN(modifiedNumber)) {
    return "NA";
  } else {
    return modifiedNumber;
  }
};

export function PrintGrades(id, year_id) {
  const resolvedYearId = year_id !== undefined ? year_id : id;
  const URL = `${BASE_URL}/student/getcourses.php`;
  axios
    .post(URL, { id: id, year_id: resolvedYearId })
    .then((res) => {
      const responseData = res.data?.data || {};
      const progressReport = responseData.data || responseData;
      const errorMsg = responseData.errorMsg || progressReport.errorMsg;

      if (errorMsg) {
        Swal.fire("", errorMsg, "warning");
        return;
      }

      const reportHtml = progressReport.report || responseData.report;
      if (reportHtml) {
        PrintElem(reportHtml);
      } else {
        Swal.fire("", "Report could not be generated", "warning");
      }
    })
    .catch((err) => {
      console.error("Error in PrintGrades:", err);
      Swal.fire("Error while printing report!", "", "error");
    });
}

export function DateFormat(date){
    let options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'};
    let d = new Date(date);
    return d.toLocaleString('en-us',options)
}

export function getFormattedDate() {
    const date = new Date();

    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    let hour = date.getHours().toString();
    hour = hour.length > 1 ? hour : '0' + hour;

    let minute = date.getMinutes().toString();
    minute = minute.length > 1 ? minute : '0' + minute;

    let second = date.getSeconds().toString();
    second = second.length > 1 ? second : '0' + second;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
}

export function formatPrintValue(val, fallback = "-") {
    if (val === null || val === undefined) return fallback;
    if (typeof val === "string") {
        const trimmed = val.trim();
        if (
            trimmed === "" ||
            trimmed.toLowerCase() === "null" ||
            trimmed.toLowerCase() === "undefined" ||
            trimmed === "0000-00-00"
        ) {
            return fallback;
        }
        return trimmed;
    }
    if (typeof val === "number") return val;
    if (typeof val === "boolean") return val ? "Yes" : "No";
    return fallback;
}
